import {
    FETCH_LOCATION_BASED_REQUEST,
    FETCH_LOCATION_BASED_SUCCESS,
    FETCH_LOCATION_BASED_FAILURE,
    FETCH_LOCATION_BASED_EMPLOYEES_REQUEST,
    FETCH_LOCATION_BASED_EMPLOYEES_SUCCESS,
    FETCH_LOCATION_BASED_EMPLOYEES_FAILURE
} from "../constants/LocationBasedConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,

    empLoading: false,
    empData: [],
    empError: null
};

const LocationBasedReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LOCATION_BASED_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_LOCATION_BASED_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_LOCATION_BASED_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case FETCH_LOCATION_BASED_EMPLOYEES_REQUEST:
    return {
        ...state,
        empLoading: true,
        empError: null,
    };

    case FETCH_LOCATION_BASED_EMPLOYEES_SUCCESS:
        return {
            ...state,
            empLoading: false,
            empData: action.payload,
            empError: null,
        };

    case FETCH_LOCATION_BASED_EMPLOYEES_FAILURE:
        return {
            ...state,
            empLoading: false,
            empError: action.payload,
        };

            default:
                return state;
        }
};


export default LocationBasedReducer;
